import React, { useState, useEffect } from 'react'
import { Box, Paper, Loader, Text, Table, Anchor, ScrollArea } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { getLatestAbandonedCartItems } from '../../../services/dashboard'
import classes from '../../../assets/module-css/AdminLayout.module.css'

const DashboardLatestAbandonedCartItems = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [cartItems, setCartItems] = useState([])

  const fetchAbandonedCartItems = async () => {
    setLoading(true)
    try {
      const response = await getLatestAbandonedCartItems()
      if (response?.data) {
        const items = response.data.cartItemsV2All?.data || []
        setCartItems(items.slice(0, 10))
      }
    } catch (error) {
      console.error('Error fetching abandoned cart items:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAbandonedCartItems()
  }, [])

  const renderLoading = () => {
    return (
      <Box ta='center' my={100}>
        <Loader size='sm' />
        <Text c='gray.6' fz={14} mt={8}>Loading Data</Text>
      </Box>
    )
  }

  const renderContent = () => {
    if (cartItems.length === 0) {
      return (
        <Box ta='center' my={80}>
          <Text c='gray.6' fz={14}>No abandoned cart items found</Text>
        </Box>
      )
    }

    return (
      <ScrollArea h={290} type='auto' offsetScrollbars>
        <Table highlightOnHover style={{ fontSize: '13px', tableLayout: 'fixed', width: '100%' }}>
          <Table.Thead style={{ backgroundColor: '#f8f9fa', position: 'sticky', top: 0, zIndex: 1 }}>
            <Table.Tr>
              <Table.Th style={{ width: '40%' }}>By User</Table.Th>
              <Table.Th style={{ width: '60%' }}>Product Name</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody style={{ verticalAlign: 'top' }}>
            {cartItems.map((item, index) => {
              const userName = item.user?.name || 'Anonymous'
              const userId = item.user?.id
              const productName = item.productName || item.product?.title || '-'
              const formattedDate = item.created_at
                ? dayjs(item.created_at).format('DD MMM YYYY, HH:mm')
                : '-'

              return (
                <Table.Tr key={index}>
                  <Table.Td style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <Box>
                      {userId ? (
                        <Anchor
                          onClick={() => navigate(`/users/${userId}`)}
                          style={{ cursor: 'pointer' }}
                          fw={600}
                          fz={13}
                          c="blue"
                        >
                          {userName}
                        </Anchor>
                      ) : (
                        <Text fw={600} fz={13} c="gray.7">
                          {userName}
                        </Text>
                      )}
                      {userId && (
                        <Text fz={11} c="dimmed">
                          ID: {userId}
                        </Text>
                      )}
                      <Text fz={11} c="gray.5" mt={4}>
                        {formattedDate}
                      </Text>
                    </Box>
                  </Table.Td>
                  <Table.Td>
                    <Text fz={13} lineClamp={3} style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                      {productName}
                    </Text>
                  </Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    )
  }

  return (
    <Paper shadow="sm" p='md' withBorder radius='md' my='lg' style={{ minHeight: '380px' }}>
      <Text className={classes.titleLayout} mb='md'>Latest Abandoned Cart Items</Text>
      <Box>
        {loading ? renderLoading() : renderContent()}
      </Box>
    </Paper>
  )
}

export default DashboardLatestAbandonedCartItems
